import { useEffect, useRef, useState } from "react";
import { Plus, Search } from "react-feather";
import { FaSearch } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getCompanies } from "../../api/companyApi";
import {
  documentManagementSearch,
  getDynamicTemplatesByManagementTypeAndCategory,
  inspectionManagementSearch,
} from "../../api/documentManagementApi";
import {
  getBulkDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Tab from "../../components/Tab";
import AddDocument from "../../components/fleet/AddDocument";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { activeById, FORMS, MODULES } from "../../const";
import { formatToDateOnlyFromJsonDate } from "../../dateConfig";
import AddFavTemplateDocument from "../../components/fleet/AddFavTemplateDocument";
import { getDynamicTemplateById } from "../../api/templateApi";
import useUserCompany from "../../hooks/useUserCompany";

const DocumentManagement = () => {
  const location = useLocation();
  const userCompany = useUserCompany();
  const [searchParams] = useSearchParams();
  const { pathname } = location;
  const gridRef = useRef(null);
  const [tab, setTab] = useState(1);
  const user = useSelector((state) => state.user);

  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isSearchResultsPending, setIsSearchResultsPending] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawer2Open, setIsDrawer2Open] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [templateSetLoading, setTemplateSetLoading] = useState(false);

  const handleAccordionClick1 = () => {
    setActiveAccordion1(!activeAccordion1);
  };
  const [tdhId, setTdhId] = useState("");
  const [tdhCode, setTdhCode] = useState("");
  const [dateTypeOptions, setDateTypeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [managementTypeOptions, setManagementTypeOptions] = useState([]);
  const [statusOpt, setStatusOpt] = useState([]);
  const [inspectionStatusOptions, setInspectionStatusOptions] = useState([]);
  const [overallStatusOptions, setOverallStatusOptions] = useState([]);
  const [templateList, setTemplateList] = useState([]);

  const [vehicleNumber, setVehicleNumber] = useState("");
  const [transporter, setTransporter] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dateType, setDateType] = useState(3);
  // const [user, setUser] = useState("");
  const [category, setCategory] = useState("");
  const [managementType, setManagementType] = useState("");
  const [status, setStatus] = useState("");
  const [code, setCode] = useState("");
  const [overallStatus, setOverallStatus] = useState("");
  const [template, setTemplate] = useState("");
  const [dyhId, setDyhId] = useState(null);
  const [favMode, setFavMode] = useState(false);

  const [isDm, setIsDm] = useState(true);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [dyhTemplate, setDyhTemplate] = useState("");
  const navigate = useNavigate();
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );

  useEffect(() => {
    if (window.location.pathname.includes("document-management")) {
      setIsDm(true);
    } else {
      setIsDm(false);
    }

    handleReset();
  }, [pathname]);

  useEffect(() => {
    (async () => {
      if (window.location.pathname.includes("inspection-create")) {
        setFavMode(true);
        const dyhIdStr = searchParams.get("dyhId");
        const dyhId = dyhIdStr ? Number(dyhIdStr) : null;
        setDyhId(dyhId);

        if (dyhId) {
          const dataRow = await getDynamicTemplateById(dyhId);
          setDyhTemplate(dataRow.dyhTemplate);
        }
        handleDrawer2Open();
      }
    })();
  }, [location.pathname, location.search, searchParams]);

  useEffect(() => {
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
  }, []);

  useEffect(() => {
    (async () => {
      if (!favMode) {
        setIsLoading(true);
        // new
        const {
          fleet_date_type: dateTypeData,
          inspection_type: managementTypeOpt,
          inspection_category: categoryOpt,
          status,
          inspaction_overall: overallStatus,
          inspection_status: inspectionStatus,
        } = await getBulkDropdownData([
          { key: "fleet_date_type" },
          { key: "inspection_type" },
          { key: "inspection_category" },
          { key: "status" },
          { key: "inspaction_overall" },
          { key: "inspection_status" },
        ]);

        setDateTypeOptions(dateTypeData);
        setManagementTypeOptions(managementTypeOpt);
        setCategoryOptions(categoryOpt);
        setStatusOpt(status);
        setOverallStatusOptions(overallStatus);
        setInspectionStatusOptions(inspectionStatus);

        setIsLoading(false);
      }
    })();
  }, [favMode]);

  useEffect(() => {
    (async () => {
      if (!managementType || !category) {
        return;
      }
      setTemplateSetLoading(true);
      const templateSet = await getDynamicTemplatesByManagementTypeAndCategory(
        managementType,
        category,
      );
      console.log("templateSet", templateSet);

      const templateSetOptions = templateSet?.map((template) => ({
        key: template.dyhId,
        value: template.dyhId,
        text: template.dyhTemplate,
      }));
      setTemplateList(templateSetOptions);
      setTemplateSetLoading(false);
    })();
  }, [managementType, category]);

  const handleSearch = async () => {
    setIsSearchResultsPending(true);

    try {
      const data = {
        company: company,
        user: user.username,
        tdhCategory: category,
        tdhInspectionType: managementType,
        tdhTemplate: template,
        vehVehicleno: vehicleNumber,
        code: code,
        datetype: dateType,
        fromdate: fromDate,
        todate: toDate,
        tdhOverallStatus: overallStatus,
        tdhStatus: status,
        tdhTransporter: transporter ? Number(transporter) : null,
      };
      const response = await documentManagementSearch(data);

      for (let item of response) {
        item.tdhActionDate = item.tdhActionDate
          ? formatToDateOnlyFromJsonDate(item.tdhActionDate)
          : "N/A";
        item.tdhNextDate = item.tdhNextDate
          ? formatToDateOnlyFromJsonDate(item.tdhNextDate)
          : "N/A";
        item.tdhActiveName = item.tdhActive
          ? activeById[item.tdhActive]
          : "N/A";
      }
      handleAccordionClick1(false);
      response.sort((a, b) => b.tdhId - a.tdhId);
      setSearchResults(response);
    } catch (e) {
      console.error(e);
    }
    setSearchClicked(true);
    setIsSearchResultsPending(false);
  };

  const handleSearchInspection = async () => {
    setIsSearchResultsPending(true);

    try {
      const data = {
        company: company,
        user: user.username,
        tdhCategory: category,
        tdhInspectionType: managementType,
        tdhTemplate: template,
        vehVehicleno: vehicleNumber,
        code: code,
        datetype: dateType,
        fromdate: fromDate,
        todate: toDate,
        tdhOverallStatus: overallStatus,
        tdhStatus: status,
        tdhTransporter: transporter ? Number(transporter) : null,
      };

      const response = await inspectionManagementSearch(data);

      for (let item of response) {
        item.tdhActionDate = item.tdhActionDate
          ? formatToDateOnlyFromJsonDate(item.tdhActionDate)
          : "N/A";
        item.tdhNextDate = item.tdhNextDate
          ? formatToDateOnlyFromJsonDate(item.tdhNextDate)
          : "N/A";
        item.tdhActiveName = item.tdhActive
          ? activeById[item.tdhActive]
          : "N/A";
      }
      handleAccordionClick1(false);
      response.sort((a, b) => b.tdhId - a.tdhId);
      setSearchResults(response);
    } catch (e) {
      console.error(e);
    }
    setSearchClicked(true);
    setIsSearchResultsPending(false);
  };

  const handleQuickSearchInspection = async (data) => {
    setIsSearchResultsPending(true);

    try {
      const response = await inspectionManagementSearch(data);

      for (let item of response) {
        item.tdhActionDate = item.tdhActionDate
          ? formatToDateOnlyFromJsonDate(item.tdhActionDate)
          : "N/A";
        item.tdhNextDate = item.tdhNextDate
          ? formatToDateOnlyFromJsonDate(item.tdhNextDate)
          : "N/A";
        item.tdhActiveName = item.tdhActive
          ? activeById[item.tdhActive]
          : "N/A";
      }
      handleAccordionClick1(false);
      response.sort((a, b) => b.tdhId - a.tdhId);
      setSearchResults(response);
    } catch (e) {
      console.error(e);
    }
    setSearchClicked(true);
    setIsSearchResultsPending(false);
  };

  const handleReset = () => {
    setVehicleNumber("");
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    const formattedToday = new Date().toISOString().split("T")[0];
    setFromDate(formattedWeekAgo);
    setToDate(formattedToday);
    setCompany("");
    setDateType(3);
    // setUser("");
    setCategory("");
    setManagementType("");
    setStatus("");
    setCode("");
    setOverallStatus("");
    setSearchClicked(false);
    setSearchResults([]);
    setActiveAccordion1(true);
    setTransporter(null);
    setResetSearchFields((p) => !p);
  };

  const handleDrawerClose = () => {
    setEditMode(false);
    setIsDrawerOpen(false);
  };

  const handleDrawerOpen = () => {
    setEditMode(false);
    setTdhCode("");
    setIsDrawerOpen(true);
  };

  const handleDrawer2Close = () => {
    setFavMode(false);
    setEditMode(false);
    setIsDrawer2Open(false);
    navigate("/fleet/inspection-process");
  };

  const handleDrawer2Open = () => {
    setEditMode(false);
    setIsDrawer2Open(true);
  };

  console.log("favMode", favMode);

  return (
    <div>
      <div
        className="ui tabular attached"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu top attached">
          <Tab
            Icon={FaSearch}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            label="Search"
          />
        </div>
        <Button
          label={"New"}
          Icon={Plus}
          template="drawerOpen"
          onClick={handleDrawerOpen}
          authenticated={true}
          form={
            isDm
              ? FORMS.FLEET.DOCUMENT_MANAGEMENT.form
              : FORMS.FLEET_INSPECTION.INSPECTION_PROCESS.form
          }
          module={MODULES.Fleet}
          editMode={false}
          disabled={favMode ? true : false}
        />
      </div>

      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none", width: "100%" }}
      >
        <div
          class="ui styled accordion"
          style={{ width: "100%", marginBottom: "10px" }}
        >
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => handleAccordionClick1(!activeAccordion1)}
          >
            <div>
              Click here to search
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i class="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header">Information</h4>

                <div className="three fields">
                  <Dropdown
                    clearable
                    search={true}
                    options={categoryOptions}
                    placeholder="Category"
                    label="Category"
                    value={category}
                    onChange={(e, data) => {
                      setCategory(data.value);
                    }}
                  />
                  <Dropdown
                    clearable
                    search={true}
                    options={managementTypeOptions}
                    placeholder={"Management Type"}
                    label="Management Type"
                    value={managementType}
                    onChange={(e, data) => {
                      setManagementType(data.value);
                    }}
                  />

                  <Dropdown
                    clearable
                    search={true}
                    options={templateList}
                    placeholder={
                      templateSetLoading
                        ? "Loading..."
                        : templateList?.length === 0
                          ? "No Templates"
                          : "Select Template"
                    }
                    label="Template"
                    value={template}
                    onChange={(e, data) => {
                      setTemplate(data.value);
                    }}
                    disabled={
                      templateSetLoading ||
                      !managementType ||
                      !category ||
                      templateList?.length === 0
                    }
                  />
                </div>
                <div className="three fields">
                  <Input
                    label="Vehicle Number"
                    type="text"
                    name="vehicleNumber"
                    value={vehicleNumber}
                    onChange={(e) => setVehicleNumber(e.target.value)}
                  />
                  <SearchDropdown
                    key={2}
                    editMode={false}
                    reset={resetSearchFields}
                    setReset={setResetSearchFields}
                    occupySpace={false}
                    value={transporter}
                    onResultSelect={(data) => setTransporter(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                  />
                  <Input
                    label="Document/Inspection Code"
                    type="text"
                    name="code"
                    placeholder={"Example - TDH-00000018,TDH-00000022"}
                    value={code}
                    onChange={(e) => {
                      setCode(e.target.value);
                    }}
                  />
                  <Dropdown
                    label="Date Type"
                    clearable={false}
                    options={dateTypeOptions}
                    placeholder="Date Type"
                    style={{ height: "20px" }}
                    value={dateType}
                    onChange={(e, data) => {
                      setDateType(data.value);
                    }}
                  />
                </div>
                <div className="four fields">
                  <Input
                    label="From Date"
                    type="date"
                    name="fromDate"
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                    }}
                  />

                  <Input
                    label="To Date"
                    type="date"
                    name="toDate"
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                    }}
                  />

                  <Dropdown
                    clearable
                    search={true}
                    options={overallStatusOptions}
                    placeholder="Overall Status"
                    label="Overall Status"
                    value={overallStatus}
                    onChange={(e, data) => {
                      setOverallStatus(data.value);
                    }}
                  />
                  <Dropdown
                    clearable
                    options={statusOpt}
                    placeholder="Status"
                    label="Status"
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={isDm ? handleSearch : handleSearchInspection}
                      disabled={favMode ? true : false}
                    />
                    <Button
                      template="searchReset"
                      onClick={handleReset}
                      disabled={favMode ? true : false}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>

        {searchClicked && (
          <>
            {isSearchResultsPending ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={isSearchResultsPending}
                autoHeight={true}
                // rowHeight={50}
                searchable={true}
                config={[
                  {
                    headerName: "Code",
                    field: "tdhCode",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                    pinned: "left",
                    filter: true,
                    cellStyle: { backgroundColor: "#fff9c4" },
                  },
                  {
                    headerName: "Category Name",
                    field: "tdhCategoryName",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Inspection Type",
                    field: "tdhInspectionTypeName",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Template",
                    field: "dyhTemplate",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Vehicle Number",
                    field: "vehVehicleNo",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Transporter",
                    field: "tdhTransporterName",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "From Date",
                    field: "tdhActionDate",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "To Date",
                    field: "tdhNextDate",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Overall Status",
                    field: "tdhOverallStatusName",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Overall %",
                    field: "tdhOverall",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "tdhStatusName",
                    width: 180,
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "tdhActiveName",
                    width: 180,
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                content={searchResults}
                ref={gridRef}
                onCellDoubleClicked={(props) => {
                  setIsDrawerOpen(true);
                  setTdhCode(props.data.tdhCode);
                  setTdhId(props.data.tdhId);
                  setEditMode(true);
                }}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          isDm ? (
            !editMode ? (
              <h3>Document Management</h3>
            ) : (
              <h3>Update {" " + tdhCode}</h3>
            )
          ) : !editMode ? (
            <h3>Create Inspection</h3>
          ) : (
            <h3>Update Inspection {" " + tdhCode}</h3>
          )
        }
        body={
          <AddDocument
            isDm={isDm}
            editMode={editMode}
            setEditMode={setEditMode}
            handleDrawerClose={handleDrawerClose}
            dropdownOptions={{
              categoryOptions,
              managementTypeOptions,
              statusOpt,
              overallStatusOptions,
              templateList,
              inspectionStatusOptions,
            }}
            tdhCode={tdhCode}
            tdhId={tdhId}
          />
        }
        style={{ width: "90vw" }}
      />

      <SideDrawer
        open={isDrawer2Open}
        handleDrawerClose={handleDrawer2Close}
        head={
          <h3>
            Create Inspection by:{" "}
            <b>
              <i>{dyhTemplate}</i>
            </b>
          </h3>
        }
        body={
          <AddFavTemplateDocument
            isDm={false}
            editMode={false}
            handleDrawerClose={handleDrawer2Close}
            tdhCode={""}
            tdhId={null}
            dyhId={dyhId}
            handleQuickSearchInspection={handleQuickSearchInspection}
          />
        }
        style={{ width: "90vw" }}
      />
    </div>
  );
};

export default DocumentManagement;
